import { useEffect, useMemo } from 'react';
import { useRouteParam } from '@/common/hooks/useRouteParam';
import { useSetSideBarLinkBadgeCount } from '@/state/navigation';
import { useBuyerAgreementMissingFields } from '@/views/Buyers/views/BuyerAgreement/hooks/useBuyerAgreementMissingFields';
import { useBuyerProfileMissingFields } from '@/views/Buyers/views/BuyerProfile/hooks/useBuyerProfileMissingFields';

export function useMissingRequiredFields() {
  const clientGroupId = useRouteParam('clientGroupId');
  const setLinkBadgeCount = useSetSideBarLinkBadgeCount();

  const {
    missingAgreementFields,
    clientGroup,
    loading: agreementLoading,
  } = useBuyerAgreementMissingFields(clientGroupId);

  const { missingProfileFields, loading: profileLoading } =
    useBuyerProfileMissingFields(clientGroupId);

  // Set badge counts and combined missing fields state
  const allMissingFields = useMemo(
    () => [...missingAgreementFields, ...missingProfileFields],
    [missingAgreementFields, missingProfileFields],
  );

  useEffect(() => {
    if (!clientGroup) {
      return;
    }

    setLinkBadgeCount(
      clientGroup.id,
      ['Buyer Agreement'],
      missingAgreementFields.length,
      allMissingFields,
    );
    setLinkBadgeCount(
      clientGroup.id,
      ['Buyer Profile'],
      missingProfileFields.length,
      allMissingFields,
    );
  }, [
    clientGroup,
    setLinkBadgeCount,
    missingAgreementFields,
    missingProfileFields,
    allMissingFields,
  ]);

  return {
    missingAgreementFields,
    missingProfileFields,
    loading: agreementLoading || profileLoading,
  };
}
